<template>
        <Iframe :url-prop="map_final" />
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from 'axios';
import Iframe from "@/components/Iframe.vue";
export default {
    components: {Iframe},
    props: ['eventName'],
    name: 'MapKrpano',
    computed: {
        ...mapGetters([
            'maps', "checkIOS", "checkMobile","checkSafari", 'webviewIframe',
        ]),
        map_final: function () {
            let url;
            if (this.checkIOS && this.maps.ios) {
                url = this.maps.ios;
            } else if ((this.checkIOS || this.checkMobile) && this.maps.android) {
                url = this.maps.android;
            } else if ((this.checkSafari) && this.maps.safari) {
                url = this.maps.safari;
            } else {
                url = this.maps.default;
            }
            return (this.webviewIframe) ? url + '?webview=1' : url;
        }
    },
    data() {
        return {
        }
    },
    methods: {
    },
    mounted() {
    },
    beforeDestroy() {
    },
}
</script>

<style scoped></style>